import { createListFilters, IOption } from '../../../../../components'

export type UnidadesFilters = {
  /** Nome da unidade/setor (busca parcial). */
  unidade: string
  empresa?: IOption<number>
}

export const { ListFiltersProvider, useListFilters } = createListFilters<UnidadesFilters>({
  unidade: '',
  empresa: undefined,
})
